// Module
var code = "<div class=\"modal-header\" modal-movable> <h4 class=\"modal-title\" id=\"modal-query-path-title\" translate>common.path</h4> </div> <div class=\"modal-body modal-scroll\" id=\"modal-query-path-body\"> <query-select-path path=\"$ctrl.path\"></query-select-path> </div> ";
// Exports
export default code;